import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/recurring_order'

import component from 'components/RecurringOrders/New'

const formName = 'new-recurring_order'
const fields = ['name']

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  onSubmit: (data) => {
    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, {}, fields))
  }
})

const mapStateToProps = (state) => ({
  recurring_order: state.recurring_order
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/RecurringOrders/containers/NewRecurringOrderContainer.js